import React from 'react'

export interface IPageContext {
  sidebar?: any
  sidebarMode?: string
  sidebarOpen: boolean
  setSidebarOpenState: (isOpen: boolean) => void
}

const PageContext = React.createContext({ sidebar: false } as IPageContext)
export default PageContext
